import styles from './ClubMeet.module.scss';

import { useQuery } from 'react-query';
import { NavLink, useLocation } from 'react-router-dom';
import Filter, { FilterItem } from '../../../components/Filter/CustomFilter';
import FloatButton from '../../../components/FloatButton/FloatButton';
import HeaderPage from '../../../components/HeaderPage/HeaderPage';
import useSearchParam from '../../../hooks/useQueryParams';
import { getClubMeets } from '../../../service/meet';
import { useUserStore } from '../../../store/useUser';
import { main_color_50 } from '../../../styles/_variables';
import { getClubIdByPathname, getClubNameByPathname, getFormattedClubName, navigateToClub } from '../../../utils/club';
import Meet from './Meet/Meet';

import { useEffect } from 'react';
import useHeader from '../../../hooks/useHeader';
import { Spin } from 'antd';

interface LocationState{
  pathname: string;
}

const ClubMeet = () => {
  const [searchState, setSearchState] = useSearchParam<string>('date')

  const userId = useUserStore(state => state.uid)
  const userIsAdmin = useUserStore(state => state.userIsAdmin)
  const userIsMediator = useUserStore(state => state.userIsMediator)
  const profile = useUserStore(state => state.profile)

  useHeader({ header: getFormattedClubName(), subheader: 'Encontros' });

  const clubId = getClubIdByPathname();
  const clubName = getClubNameByPathname();
  const isAdmin = userIsAdmin(clubId)
  const isMediator = userIsMediator(clubId)

  if(!searchState) setSearchState('waiting');

  const { data: meets, isFetching } = useQuery(
    ['meets', 'club', clubId, searchState],
    () => getClubMeets(clubId, searchState),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  return (
    <section>
      <HeaderPage header="Encontros" bageColor={main_color_50}/>
      <Filter>
        <FilterItem 
          onClick={e => setSearchState('waiting')} 
          active={searchState === 'waiting'}>
            Aguardando
        </FilterItem>
        <FilterItem 
          onClick={e => setSearchState('today')} 
          active={searchState === 'today'}>
            Hoje
        </FilterItem>
        <FilterItem 
          onClick={e => setSearchState('finish')} 
          active={searchState === 'finish'}>
            Finalizado
        </FilterItem>
      </Filter>
      <Spin spinning={isFetching}>
        <div className={styles.meets}>
          {meets?.map(meet => 
            <Meet
              meet={meet}
              key={meet?.id}
            />
          )}
        </div>
      </Spin>
      { (profile !== 'Clubista' && isAdmin) ? 
        <NavLink to={navigateToClub(clubName,clubId, '/meet/add')}>        
          <FloatButton>
            +
          </FloatButton>
        </NavLink>
        : null
      }
    </section>
  )
}

export default ClubMeet;